import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-pencil",
  "use": "icon-si-glyph-pencil-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-pencil\" id=\"icon-si-glyph-pencil\">\n    <!-- Generator: Sketch 3.0.3 (7891) - http://www.bohemiancoding.com/sketch -->\n    <title>992</title>\n    \n    <defs></defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M16.479,2.536 L14.474,0.546 C13.935,0.00899999997 13.091,-0.019 12.59,0.482 L3.47,9.616 C3.47,9.616 1.158,14.936 1.001,15.366 C0.876,15.706 1.307,16.137 1.605,15.991 C2.085,15.754 7.345,13.471 7.345,13.471 L16.487,4.299 C16.989,3.797 17.018,3.073 16.479,2.536 L16.479,2.536 Z M2.312,13.906 L4.033,10.279 L4.015,10.985 L5.013,10.971 L14.537,1.529 L15.796,2.765 L6.612,11.73 L6.385,12.482 L6.871,12.968 L3.06,14.624 L2.312,13.906 L2.312,13.906 Z\" fill=\"#434343\" class=\"si-glyph-fill\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-pencil.svg
// module id = fiCc
// module chunks = 62